// extracted by mini-css-extract-plugin
module.exports = {"SurveyFooter":"SurveyLayer_SurveyFooter__LPN1z"};